import styled from '@emotion/styled'

import { colors, metrics } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'
import { themedValue } from 'component-library/__styling/themed-value'
import { Product } from 'component-library/__product'

export const StyledFootnote = styled('p')(
    {
        fontWeight: 400,
    },
    breakWords,
    ({ theme }) => ({
        fontFamily: themedValue(theme, {
            thewest: theme.fonts.body,
            fallback: theme.fonts.sansSerif,
        }),
        fontSize: calcRem(14),
        lineHeight: themedValue(theme, {
            thewest: 1.25,
            perthnow: 1.429, // 20px / 14px
            fallback: undefined,
        }),
        color: themedValue(theme, {
            thewest: colors.black,
            perthnow: colors.perthnow.greyMoonstone,
            fallback: undefined,
        }),
        margin: themedValue(theme, {
            thewest: `${calcRem(metrics.thewest.textMargin)} 0 0 0`,
            perthnow: `${calcRem(metrics.perthnow.textMargin)} 0 0 0`,
            fallback: undefined,
        }),
        // Needs to clear potential floated images
        clear: theme.kind === Product.TheWest ? 'both' : undefined,
    })
)
